<template>
  <div class="my-release-search-wrap">
    <div class="my-release-search-text">リリース検索</div>
    <form @submit.prevent="onClickedSearch">
      <input
        v-model="keyword"
        class="my-release-search"
        type="search">
    </form>
    <a
      class="c-btn c-btn--search"
      @click.prevent="onClickedSearch">
      <img
        src="/img/common/icon-search.png"
        alt="">
      検索
    </a>
  </div>
</template>

<script>
export default {
  name: 'RevenueShareSearch',
  data() {
    return {
      keyword: '',
    }
  },
  methods: {
    onClickedSearch() {
      this.$emit('setKeyWord', this.keyword)
    },
  },
}

</script>

<style scoped>
</style>
